import React from 'react';
import Button from '../../shared/button';

import { Modal } from 'react-bootstrap';

function Popup({ title, isStatic = false, classes, showModal, handleClose, closeBtn = 'Close', saveBtn = 'Save', isValidSave, body, isValid = false }) {


  return (<>
    <Modal show={showModal} onHide={handleClose.bind(null, false)} backdrop={isStatic ? 'static' : true}>

      <Modal.Header closeButton={!isStatic}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`d-flex justify-content-center ${classes}`}>
        {body}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        {closeBtn &&
          <Button text={closeBtn} classes="white" variant="outline-dark" handleClick={handleClose.bind(null, false)} />
        }
        {saveBtn && isValidSave &&
          <Button disabled={!isValid} text={saveBtn} variant="primary" handleClick={handleClose.bind(null, true)} />
        }
      </Modal.Footer>
    </Modal>
  </>);
}

export default Popup;